<template>
  <figure :id="figureAttr.id">
    <label v-html="figureAttr.label"></label>
    <p><img :src="figureAttr.url" :alt="figureAttr.alt" /></p>
    <figcaption v-html="figureAttr.caption"></figcaption>
  </figure>
</template>
<script>
  export default {
    name: 'content-figure',
    props: ['figureAttr']
  }
</script>
<style lang="scss" scoped>
  figure {
    text-align: center;
    img {
      width: 100%;
    }
    @media (min-width: $breakpoint-md) {
      img {
        width: 50%;
      }
   }
  }
</style>



// WEBPACK FOOTER //
// ContentFigureComponent.vue?5a4b0a72